<template>
  <el-time-select ref="rcTimeSelect" :value="value" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
  name: "RcTimeSelect",
  props: {
    value: {
      default: ""
    }
  }
};
</script>
